type Translate = (k: string, v?: Record<string, string | number>) => string;

// His `errMsg` never shows the browser's own words ("Failed to fetch", "Load failed"): a request that
// never reached the server says so in the screen's language (`offline`); a refusal gives the server's own
// reason, already in that language; a crash (Rails' own `{status, error}` page) or a page the server did
// not write, its status.
export function failText(t: Translate, e: unknown, offline: string) {
  const x = e as { status?: unknown; body?: { error?: unknown; status?: unknown } } | null;
  if (typeof x?.status !== "number") return t(offline);
  return typeof x.body?.error === "string" && x.body.status === undefined ? x.body.error : t("error.request", { status: x.status });
}

// His `addMedia` catch: every failure is one of his own sentences — a refusal the screen wrote itself,
// already translated (a photo it cannot read, a file too heavy, the storage saying no: a plain Error with
// no status), or failText's. A TypeError is the browser's own "Failed to fetch" / "Load failed": offline.
export function mediaFailText(t: Translate, e: unknown, offline: string) {
  return e instanceof Error && e.name === "Error" && !("status" in e) ? e.message : failText(t, e, offline);
}

// His `addMedia` catch for a job's file (the job's own, a line's, an issue's, the tablet's): one of his
// sentences, whatever failed. A check the screen made itself already wrote his; a refusal the server gives
// one of his codes gets his sentence for it (too heavy, a type the job does not take); anything else — the
// network, the storage refusing the PUT, the server's own error page, a refusal with no code — is his
// "could not be saved", never a status (MON-058).
export function jobMediaFailText(t: Translate, e: unknown, file: { video: boolean; mb: number; max: number }) {
  if (e instanceof Error && e.name === "Error" && !("status" in e) && !("refused" in e)) return e.message;
  const code = (e as { body?: { code?: unknown } } | null)?.body?.code;
  if (code === "too_large") return t(file.video ? "mediaJob.videoBig" : "mediaJob.tooBig", { mb: file.mb, max: file.max });
  if (code === "unsupported_type") return t(file.video ? "mediaJob.videoType" : "mediaJob.photoType");
  return t(file.video ? "media.failVideo" : "media.failPhoto");
}
